import React, { useState } from 'react';
import clsx from 'clsx';

/***Component***/
const VerticalTabItems = (props) => {
  const { onTabClick, initialTabName, tabNames } = props;

  const [active, setActive] = useState(initialTabName);
  const handleTabClick = (name) => {
    onTabClick(name);
    setActive(name);
  };

  return (
    <div className="tab-listing-categories">
      {tabNames?.map((tabName, index) => {
        const shouldRenderCategory = !!tabName;
        if (!shouldRenderCategory) {
          return null;
        }
        return (
          <div
            key={index}
            className={clsx(
              'search-item-category flex-it flex-align-item-center',
              active.id === tabName.id ? 'selected' : ''
            )}
            onClick={() => handleTabClick(tabName)}
          >
            {tabName?.name}
          </div>
        );
      })}
    </div>
  );
};

export default VerticalTabItems;
